import styled, { css } from 'styled-components'
import { SLink, SParagraph } from '@components/Typography'
import { SButtonTab } from '@components/Button/Button'
import { colors } from '@styles/theme'
import Cross from '@icons/PlusAero.inline.svg'
import { above } from '@styles/mixins/breakpoints'
import { IWithOpened } from '@components/Questions/types'

export const SLinkAero = styled(SLink)`
  color: ${colors.darkBlue};
  display: inline-block;
`

export const STabList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`

export const STabListItem = styled.li<IWithOpened>`
  border-bottom: ${`1px solid ${colors.steelGray}`};
  ${({ opened }) => (opened ? `background-color: ${colors.lightGray};` : '')}
  padding: 28px 20px 24px;
  transition: 0.3s;

  .ReactCollapse--collapse {
    transition: 0.3s;
  }
`

export const STitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
`

export const SIconContainer = styled.div<IWithOpened>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  padding: 6px;

  &:hover {
    cursor: pointer;
    background-color: ${({ opened }) => (opened ? colors.white : colors.lightGray)};
  }

  &:active {
    background-color: unset;
  }
`

export const SCrossIcon = styled(Cross)<IWithOpened>`
  width: 20px;
  height: 20px;
  transform: ${({ opened }) => (opened ? 'rotate(225deg)' : 'rotate(0deg)')};
  transition: 0.3s;
`

export const STextParagraph = styled(SParagraph)`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  margin: 0;
  display: flex;
  align-items: center;
`

export const STitle = styled(STextParagraph)`
  font-weight: 600;

  ${above('md')(css`
    font-size: 16px;
    line-height: 24px;
    font-weight: 400;
  `)}
`

export const SContentContainer = styled.div`
  overflow: hidden;
  padding-top: 24px;
  padding-right: 52px;
  padding-left: 20px;
  margin-left: -20px;

  & ul {
    padding: 0 0 0 20px;
    margin: 15px 0 0;
    list-style-position: outside;
    list-style-type: disc;
  }

  & li {
    margin-top: 24px;

    &:first-child {
      margin-top: 0;
    }
  }

  & p {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    margin: 0 0 15px;
    display: flex;
    align-items: center;

    &:last-of-type {
      margin: 0;
    }
  }
`

export const SButtonTabAero = styled(SButtonTab)`
  display: inline-block;
  white-space: nowrap;

  ${({ active }) =>
    active
      ? css`
          background: ${colors.darkBlue};
          color: white;
        `
      : ''}

  &:hover {
    background: ${colors.darkBlue};
    color: white;
  }

  &:first-of-type {
    margin-left: 0;
  }
`
